export default function MetricCard({ icon: Icon, label, value, hint, testid, accent = "" }) {
  return (
    <div
      data-testid={testid}
      className="group rounded-xl border border-border bg-card p-4 transition-transform duration-200 hover:-translate-y-1 hover:border-primary/40 hover:shadow-[0_10px_34px_-14px_hsl(var(--primary)/0.55)] sm:p-5"
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-muted-foreground sm:text-xs">{label}</span>
        {Icon && (
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary transition-transform duration-200 group-hover:scale-110">
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <div className={`mt-3 font-heading text-2xl font-bold tracking-tight sm:text-3xl ${accent}`}>{value}</div>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}
